/* Fashly – "Continue shopping" returns to the last collection the shopper was browsing
 * - Remembers the last collection (or search results) page visited in this browser tab
 * - On the cart page, "Continue shopping" goes back there instead of /collections/all
 * - Asks infinite-scroll.js to put the shopper back at the same spot in that collection
 */
(function () {
  "use strict";

  var LAST_KEY = "fc-last-collection";
  var RESTORE_KEY = "fc-inf-restore";
  var path = location.pathname;

  function save(url) {
    try {
      sessionStorage.setItem(LAST_KEY, url);
    } catch (e) {}
  }
  function load() {
    try {
      return sessionStorage.getItem(LAST_KEY);
    } catch (e) {
      return null;
    }
  }

  // 1. Remember collection / search pages as the shopper browses.
  if (/^\/collections\/[^\/]+\/?$/.test(path)) {
    save(path + location.search);
  } else if (/^\/search\/?$/.test(path) && /[?&]q=/.test(location.search)) {
    save(path + location.search);
  } else {
    // Product opened from inside a collection URL, e.g. /collections/maxis/products/abc
    var m = path.match(/^(\/collections\/[^\/]+)\/products\//);
    if (m && !load()) save(m[1]);
  }

  // 2. On the cart page, send "Continue shopping" back to that page.
  //    Click delegation keeps working even after Dawn re-draws the cart when quantities change.
  if (/^\/cart\/?$/.test(path)) {
    document.addEventListener(
      "click",
      function (e) {
        var a = e.target.closest && e.target.closest("a[href]");
        if (!a) return;
        if (!/continue shopping/i.test(a.textContent)) return;
        var last = load();
        if (!last) return; // nothing remembered: keep the theme's default link
        e.preventDefault();
        try {
          // infinite-scroll.js uses this to restore the shopper's position
          sessionStorage.setItem(RESTORE_KEY, "fashly-inf:" + last);
        } catch (err) {}
        location.href = last;
      },
      true
    );
  }
})();